export default __webpack_public_path__ + "static/media/SegunImg.b9e415e4.png";